export default __webpack_public_path__ + "static/media/D2G5AR-min.4269f972.jpeg";